import { Component } from '@angular/core';
import { ProductCategoryService } from '../../../../../../shared/store/product-category/product-category.service';
import { ProductCategoryModel } from '../../../../../../shared/store/product-category/types';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-product-category-details-claim-types',
  standalone: false,
  templateUrl: './product-category-details-claim-types.component.html',
  styleUrl: './product-category-details-claim-types.component.scss',
})
export class ProductCategoryDetailsClaimTypesComponent {
  productCategory$: Observable<ProductCategoryModel>;

  constructor(private readonly productCategoryService: ProductCategoryService) {
    this.productCategory$ = this.productCategoryService.getById.value$;
  }
}
